module.exports = __webpack_public_path__ + "static/tarjeta-4b3e331112bac501f77bb728dcad447e.jpg";